export const authConfig = {
  apiKey: "AIzaSyCk-cYrLecXSMtqyEIIp3N3i5-aI2wa9fg",
  authDomain: "pricesmart-e1078.firebaseapp.com",
};
